import React from 'react';
import PropTypes from 'prop-types';
import styles from './ClubRecord.module.css';
import { convertDateTime, convertMillisecondsToRecord } from 'utils/time';
import { fieldEvents } from 'config/admin/event';
import useGroupLabels from 'hooks/useGroupLabels';
import useOrganisationWords from 'hooks/useOrganisationWords';
import { formatGroupHeading } from 'utils/groupLabel';

const ClubRecord = ({ clubRecords, eventType }) => {
  // "Club record U11 F", or "Club record Y6 F" for a club that groups by year level; "School record" for a
  // school (Doug, 2026-10-27).
  const { groupingBasis } = useGroupLabels();
  const organisation = useOrganisationWords();
  const isFieldEvent =
    fieldEvents.includes(eventType) || eventType === 'High Jump';
  return (
    <>
      {clubRecords?.map((clubRecord, index) => {
        const genderLetter = clubRecord.gender?.charAt(0) || '';
        return (
          <div className={styles.container} key={index}>
            {organisation.title} record {formatGroupHeading(groupingBasis, clubRecord.ageGroup)}{' '}
            {genderLetter}: {clubRecord?.athleteName}{' '}
            {isFieldEvent
              ? `${parseFloat(clubRecord?.recordValue).toFixed(2)} m`
              : `${convertMillisecondsToRecord(clubRecord?.recordValue, 2)}`}{' '}
            - {convertDateTime(clubRecord?.achievedAt).date}
          </div>
        );
      })}
    </>
  );
};

ClubRecord.propTypes = {
  clubRecords: PropTypes.arrayOf(PropTypes.object),
  eventType: PropTypes.string,
};

export default ClubRecord;
